export class Rating {
  punctuality: number = -1;
  teamskills: number = -1;
  communication: number = -1;
  constructor() {}
}
